import React from 'react';
import { motion } from 'framer-motion';
import { XIcon } from 'lucide-react';
import { SectionHeading } from './ui/SectionHeading';
const pains = ['Hacés el blanco bien — y el cliente igual regatea el precio', 'A los 15 días se ve amarillo y el cliente no vuelve', 'No tenés sistema de corrección — improvisás con los tonos', 'No sabés cómo justificar lo que cobrás sin incomodarte', 'Ves blancos en redes con otro nivel — y no entendés qué diferencia hacen'];
export function Problem() {
  return <section id="problema" aria-label="El problema" className="border-b border-ink-700 bg-ink-900 py-16 sm:py-20" data-id="element-154" data-mp="26hobxwbx2th6">
      <div className="mx-auto w-full max-w-page px-5 sm:px-8" data-id="element-155" data-mp="1sn54v7l131sj">
        <SectionHeading label="El problema" title="¿Cuántos blancos más vas a cobrar de menos?" subtitle="No es falta de talento. Es falta de método." data-id="element-156" data-mp="1wrv0cvbryecx" />

        <ul className="mt-10 divide-y divide-ink-700 border-y border-ink-700" data-id="element-157" data-mp="1nqet2wg9ascx">
          {pains.map((pain, i) => <motion.li key={pain} initial={{
          opacity: 0,
          x: -12
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true,
          margin: '-60px'
        }} transition={{
          duration: 0.4,
          delay: i * 0.06
        }} className="flex items-start gap-4 py-5" data-id="element-158" data-mp="t8m3fjz1xoi2" data-mpi={i}>
              <XIcon className="mt-0.5 h-5 w-5 shrink-0 text-alert" aria-hidden="true" data-id="element-159" data-mp="x9pfdvdzb0e0" />
              <span className="text-base leading-relaxed text-bone sm:text-lg" data-id="element-160" data-mp="9jv3ph5ebhvc">{pain}</span>
            </motion.li>)}
        </ul>

        <p className="display mt-10 text-2xl text-bone sm:text-3xl" data-id="element-161" data-mp="jcamuhsficht">
          ¿Y si este fuera el último blanco que cobrás de menos?
        </p>
      </div>
    </section>;
}